import React, { useEffect, useState } from 'react'
import ProcessMode from './ProcessMode';
import { useParams } from 'react-router-dom';
import BottomMenu from '../BottomMenu';

function TaskProcess() {
  let nextShift = {};
  try {
    nextShift = JSON.parse(localStorage.getItem("next_shift")) || JSON.parse(localStorage.getItem("userDetailsAll")) || {};
  } catch (e) {
    nextShift = {};
  }
  const [currentShift, setCurrentShift] = useState('')
  const [nextSegment, setNextSegment] = useState('')
  const { id } = useParams()
  const [showMenu, setShowMenu] = useState(false);
  const userDetailsAll = JSON.parse(localStorage.getItem('userDetailsAll')) || {};
  function getNextSegmentName(data, currentSegmentName) {
    if (!Array.isArray(data) || !currentSegmentName) {
      return null;
    }
    for (let i = 0; i < data.length - 1; i++) {
      if (data[i]?.segment_name === currentSegmentName) {
        return data[i + 1]?.segment_name || null;
      }
    }
    return data?.[0]?.segment_name || null;
  }

  useEffect(() => {
    if (!currentShift && nextShift?.session_info?.segment_name_active) {
      setCurrentShift(nextShift?.session_info?.segment_name_active)
    }
  }, [currentShift, nextShift])

  useEffect(() => {
    if (!nextSegment && Array.isArray(nextShift?.schedule_info?.shift_array)) {
      setNextSegment(getNextSegmentName(nextShift?.schedule_info?.shift_array, nextShift?.next_shift_segment_name))
    }
  }, [nextShift, nextSegment])


  return (
    <>
      <ProcessMode
        currentShift={currentShift}
        setCurrentShift={setCurrentShift}
        nextSegment={nextSegment}
        setNextSegment={setNextSegment}
        propertiesId={userDetailsAll?.user_info?.properties_id ?? nextShift?.schedule_info?.properties_id}
        resourcesId={userDetailsAll?.user_info?.resources_id ?? nextShift?.user_info?.resources_id}
        tcs_id={nextShift?.tcs_id_active ?? nextShift?.session_info?.tcs_id_active}
        hksd_id={nextShift?.schedule_info?.schedule_details?.hksd_id}
        defaultRoomData={804}
        ss_id={id}
        showMenu={showMenu}
        setShowMenu={setShowMenu}
      />


    </>
  )
}

export default TaskProcess